export default {"src":"/_next/static/media/ok.a8a4ab79.svg","height":800,"width":800};